

import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";

import { Permission } from "@/store/user-management/types";

import vSelect from "vue-select";
import "@/scripts/dictionary";
import "@/scripts/array-operations";

import AreaSelect from "@/components/form/AreaSelect.vue";
import OverflowSelect from "@/components/form/OverflowSelect.vue";

const UserManagement = namespace("userManagement");
const eventQueue = namespace("eventqueue");

@Component({
	components: {
		"v-select": OverflowSelect,
		"area-select": AreaSelect
	}
})
export default class UserGroupDomains extends Vue {
	@Prop({ type: Array, default: [] })
	public value: any[];

	@UserManagement.Getter("getUsersDomains") public domains: any[];

	public userGroupDomains: any = [];

	mounted() {
		this.value.forEach(userGroupRole => {
			this.userGroupDomains.push(userGroupRole);
		});
	}

	addNew() {
		const newUserDomain = {
			groupId: null,
			userRoleId: null,
			inherit: true,
			groupTitle: "",
			userRoleTitle: ""
		};

		this.userGroupDomains.push(newUserDomain);
		this.value.push(newUserDomain);
		this.$emit("input", this.userGroupDomains);
	}

	async remove (remove: any) {
		this.value.remove(remove);
		this.userGroupDomains.remove(remove);

		this.$emit("input", this.value);
	}

	dataChanged () {
		this.$emit("change");
	}
}
